module.exports = __webpack_public_path__ + "static/Screenshot (63)-91c86bc500ff773033a4d03711d6be04.png";